import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

function withRouter(Component) {
  function ComponentWithRouterProps(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return <Component {...props} location={location} navigate={navigate} params={params} />;
  }

  ComponentWithRouterProps.displayName = `withRouter(${Component.displayName || Component.name})`;
  ComponentWithRouterProps.WrappedComponent = Component?.WrappedComponent || Component;

  return ComponentWithRouterProps;
}

export default withRouter;
